/**
 * The look of the step rows (user, 12/10/2026): minimal fields — no
 * border, a soft grey fill, a thin ring only while typing — and choice
 * buttons whose picked one cannot be missed.
 * For Media Devoted | Created By Ciro Autiero
 */

export const MINIMAL_FIELD =
  'h-8 rounded-md border border-transparent bg-muted/60 font-mono text-sm font-semibold tabular-nums text-foreground outline-none transition-colors hover:bg-muted focus:border-primary/40 focus:bg-background';

/** The same look on a box that holds inputs (the time picker). */
export const MINIMAL_BOX = 'h-8 border-transparent bg-muted/60 hover:bg-muted focus-within:border-primary/40 focus-within:bg-background focus-within:ring-0 focus-within:ring-offset-0';

/** A choice button: outlined when free, filled in the brand colour when picked. */
export const CHOICE_CHIP = 'inline-flex h-8 items-center whitespace-nowrap rounded-lg border text-[13px] transition-colors duration-200';
export const CHOICE_ON = 'border-primary bg-primary font-medium text-primary-foreground shadow-sm';
export const CHOICE_OFF = 'border-input bg-background text-foreground/75 hover:border-primary/50 hover:text-foreground';
